// import decode from "jwt-decode";
// import axios from 'axios';

export default class AuthHelperMethods {
  // Initializing important variables
  constructor(domain) {
    //THIS LINE IS ONLY USED WHEN YOU'RE IN PRODUCTION MODE!
    this.domain = domain || "http://demo.villassierrablanca.com"; // API server domain
  }
  login = (email, password) => {
    // const grant_type = "password";
    // Get a token from api server using the fetch api
    //  "http://demo.villassierrablanca.com/oauth/token"
    const url = new URL(process.env.REACT_APP_LOGIN);
    return this.fetch( url, {
      "method": "POST",
      "headers": {
        'Accept': 'application/json, text/plain, */*',
        'content-type': 'application/json'
    },
      body: JSON.stringify({
        "email": email,
        "password": password,
        "grant_type": 'password'
      })
    }).then(res => {
      console.log(res);
      console.log(this.domain);
      this.setToken(res.access_token, res.result.id); // Setting the token in localStorage
      console.log("error");
      return Promise.resolve(res);
    }).catch(err => {
      console.log("error");
      console.error(err);
    });
  };




//  var axios = require("axios");

// axios.request({
//   url: "/oauth/token",
//   method: "post",
//   baseURL: "http://sample.oauth.server.com/",
//   auth: {
//     username: "myUsername", // This is the client_id
//     password: "myPassword" // This is the client_secret
//   },
//   data: {
//     "grant_type": "client_credentials",
//     "scope": "public"
//   }
// }).then(respose => {
//   console.log(respose);
// });

  loggedIn = () => {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken(); // Getting token from localstorage
    return !!token && !this.isTokenExpired(token); // handwaiving here
  };

  isTokenExpired = token => {
    try {
      //const decoded = decode(token);
      const decoded = token;
      if (decoded.exp < Date.now() / 1000) {
        // Checking if token is expired.
        return true;
      } else return false;
    } catch (err) {
      console.log("expired check failed! Line 42: AuthService.js");
      return false;
    }
  };

  setToken = (idToken, currentUser) => {
    // Saves user token to localStorage
    localStorage.setItem("access_token", idToken);
    localStorage.setItem("current_user", currentUser);
  };

  getToken = () => {
    // Retrieves the user token from localStorage
    return localStorage.getItem("access_token");
  };

  logout = () => {
    // Clear user token and profile data from localStorage
    localStorage.removeItem("access_token");
  };

  getConfirm = () => {
    // Using jwt-decode npm package to decode the token
    // let answer = decode(this.getToken());
    let answer = this.getToken();
    console.log("Recieved answer!");
    return answer;
  };

  fetch = (url, options) => {
    // performs api calls sending the required authentication headers
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json"
    };
    // Setting Authorization header
    // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
    if (this.loggedIn()) {
      headers["Authorization"] = "Bearer " + this.getToken();
    }

    return fetch(url, {
      headers,
      ...options
    })
      .then(this._checkStatus)
      .then(response => response.json());
  };

  _checkStatus = response => {
    // raises an error in case response status is not a success
    if (response.status >= 200 && response.status < 300) {
      // Success status lies between 200 to 300
      return response;
    } else {
      var error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  };
}
